export default "__VITE_ASSET__Qzrnq6fS__"